import React, { useEffect } from 'react';
import moment from "moment";
import { connect } from "react-redux";
import * as actions from "redux/actions/optionHistoryActions";
import MiniLoader from 'components/MiniLoader';
import { Translate } from "react-redux-i18n";

const stylesLocal = {
    subcell: {
        padding: "5px"
    },
    cell: {
        padding: "5px"
    }
};

const FormDialog = (props) => {
    const { item, ...rest } = props;
    const [open, setOpen] = React.useState(false);

    const toNum = (value) => Number(value) || 0;
    const formatMoney = (value) => toNum(value).toFixed(2);
    const formatDate = (value) => (value ? moment(value).zone("+00:00").format("DD/MM/YYYY") : '');

    const rollValue = toNum(props.item.roll_accum);
    const isProfit = rollValue >= 0;
    const valueColor = isProfit ? '#4ade80' : '#f87171';

    const handleClickOpen = () => {
        setOpen(true);
        props.loadList({
            id: props.user_id,
            strategy: props.item.strategy,
            symbol: props.item.symbol,
            option_id: props.item.id
        }, props.token);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
    }, [props.list]);

    return (
        <div style={{ "display": "inline" }}>
            <button
                type="button"
                className={`roll-accum-btn ${isProfit ? 'roll-accum-btn--profit' : 'roll-accum-btn--loss'}`}
                onClick={handleClickOpen}
            >
                {formatMoney(rollValue)}
            </button>
            {open && (<div className='dialog' onClick={handleClose}>
                <div className='dialog-content' style={{ maxWidth: '960px' }} onClick={(e) => e.stopPropagation()}>
                    <div className='dialog-title'>Historial de rolls de {item.symbol}</div>
                    <div className='dialog-content-text'>
                        RollAccum total: <strong style={{ color: valueColor }}>{formatMoney(rollValue)}</strong>
                    </div>

                    {props.loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
                            <MiniLoader />
                        </div>
                    ) : props.list.length === 0 ? (
                        <div className='dialog-content-text'>No hay historial de rolls para esta posición.</div>
                    ) : (
                        <div style={{ overflowX: 'auto' }}>
                            <table className='table table-hover'>
                                <thead>
                                    <tr>
                                        <th>Qtt</th>
                                        <th>Open</th>
                                        <th>Close</th>
                                        <th>Fecha open</th>
                                        <th>Fecha close</th>
                                        <th>Expr</th>
                                        <th align="right">Strike</th>
                                        <th align="right">OpenTrd</th>
                                        <th align="right">CloseTrd</th>
                                        <th align="right">Tax</th>
                                        <th align="right">P/L</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.list.map((historyItem) => {
                                        const pl = toNum(historyItem.open_trade) + toNum(historyItem.close_trade) - toNum(historyItem.tax);
                                        const isProfit = pl >= 0;
                                        return (
                                            <tr key={historyItem.id || `${historyItem.reference || 'roll'}-${historyItem.open_at}-${historyItem.close_at}`}>
                                                <td style={stylesLocal.cell}>
                                                    {(historyItem.market === 'SELL' ? '-' : '+')}
                                                    {historyItem.quantity}
                                                    {historyItem.option_kind === 'CALL' ? 'C' : 'P'}
                                                </td>
                                                <td style={stylesLocal.cell}>
                                                    {formatMoney(historyItem.open_price)}{' '}
                                                    {historyItem.market === 'SELL' ? 'STO' : 'BTO'}
                                                </td>
                                                <td style={stylesLocal.cell}>
                                                    {historyItem.status === 'CLOSE' ? `${formatMoney(historyItem.close_price)} ${historyItem.market === 'SELL' ? 'BTC' : 'STC'}` : '-'}
                                                </td>
                                                <td style={stylesLocal.cell}>{formatDate(historyItem.open_at)}</td>
                                                <td style={stylesLocal.cell}>{historyItem.status === 'CLOSE' ? formatDate(historyItem.close_at) : '-'}</td>
                                                <td style={stylesLocal.cell}>{formatDate(historyItem.expire_at)}</td>
                                                <td style={stylesLocal.cell} align="right">{formatMoney(historyItem.strike)}</td>
                                                <td style={stylesLocal.cell} align="right">{formatMoney(historyItem.open_trade)}</td>
                                                <td style={stylesLocal.cell} align="right">{historyItem.status === 'CLOSE' ? formatMoney(historyItem.close_trade) : '-'}</td>
                                                <td style={stylesLocal.cell} align="right">{historyItem.status === 'CLOSE' ? formatMoney(historyItem.tax) : '-'}</td>
                                                <td style={stylesLocal.cell} align="right">
                                                    {historyItem.status === 'CLOSE' ? (
                                                        <span style={{ color: isProfit ? 'green' : 'red', fontWeight: 'bold' }}>
                                                            {formatMoney(pl)}
                                                        </span>
                                                    ) : '-'}
                                                </td>
                                                <td style={stylesLocal.cell}>{historyItem.status}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div className="dialog-actions">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            <Translate value="close" />
                        </button>
                    </div>
                </div>
            </div>
        )}
        </div>
    );
}

function mapStateToProps(reducer) {
    //console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        list: reducer.optionHistory.list,
        error: reducer.optionHistory.error,
        loading: reducer.optionHistory.loading,

    };
}
const mapDispatchToProps = dispatch => ({
    loadList: (params, token) =>
        dispatch(actions.loadList({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);
// align="left"
/**
 *   <TableCell>Reference</TableCell>
 *  <TableCell style={stylesLocal.cell} >
                                            {item.reference}
                                        </TableCell>
 */